import { useQuery } from "react-query";
import {
  CustomButton2,
  CustomModal,
  CustomRadioButtonGroup,
  CustomView,
} from "../../../../../../components";
import Context from "../../../../../../context";
import api from "../../../../../../api";
import React, { useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import {
  OFFLINE_PAYER_WAY,
  STATUS_PAY_TO_DRIVER,
} from "../../../../../../values/dropdownItems";
import { IItem } from "../../../../../../types/common.interface";
import successHandler from "../../../../../../utils/successHandler";

const ChangeStatus = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedDebt, selectedWithdrawal,setSelectedWithdrawal,getAllDebt } =
    React.useContext(Context.payAdminToDriverContext);

  const [selectedStatus, setSelectedStatus] = useState<IItem>();

  const { t } = useTranslation();

  const onSubmitHandler = async () => {
    let result: any;
    switch (selectedStatus?.value) {
      case "SEND_TO_BANK":
        result = await api.put.administrator.sendToBankManyPayToDriver({
          withdrawalId: selectedWithdrawal,
        });
        break; // Prevents fallthrough
      case "ACCEPT":
        result = await api.put.administrator.acceptManyPayToDriver({
          withdrawalId: selectedWithdrawal,
        });
        break; // Prevents fallthrough
      case "REJECT":
        result = await api.put.administrator.rejectManyPayToDriver({
          withdrawalId: selectedWithdrawal,
        });
        break; // Prevents fallthrough
    }
        if(result.CODE===2213){
      setShowModal("NONE")
      successHandler(2010)
      setSelectedWithdrawal([])
      getAllDebt.refetch()
    }
    console.log(result);
  };

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "CHANGE_STATUS"}
      minWidth={"40vw"}
      maxWidth={"45vw"}
      maxHeight={"30vh"}
    >
      <>
        <h6>{t("changeStatus")}</h6>
        <div style={{ width: "100%", marginTop: "2rem" }}>
          <CustomView.Row className="form-column-row">
            <CustomRadioButtonGroup
              menus={STATUS_PAY_TO_DRIVER}
              selected={selectedStatus as IItem}
              onClick={(event: IItem | null) => {
                setSelectedStatus(event as IItem);
                // setErrors({ ...errors, payWay: "" });
              }}
              canNull={false}
            />
          </CustomView.Row>
          <div style={{ width: "100%", marginTop: "2rem" }}>
            <CustomView.Row className="form-column-row">
              <CustomButton2 title={t("submit")} onClick={onSubmitHandler} />
            </CustomView.Row>
          </div>
        </div>
      </>
    </CustomModal>
  );
};

export default ChangeStatus;